import React from 'react'
import Logos from './Logos'
import { useNavigate } from 'react-router-dom'

const ScreenWrapper = ({ useFullWidth, children }) => {

    const navigate = useNavigate()

    const navigateToHome = () => {
        navigate('/')
    }

    return (
        <div className='w-full h-[100dvh] flex flex-col relative overflow-y-scroll' style={{
            background: 'radial-gradient(53.11% 56.94% at 50% 50%, #244767 0%, #172C3F 100%)'
        }}>
            <div className={`flex-1 w-full ${!useFullWidth && 'max-w-2xl'} mx-auto text-white p-4 flex flex-col`}>
                <div className='mb-4'>
                    <Logos margin={'mx-auto'} navigateToHome={navigateToHome}/>
                </div>
                {children}
            </div>
        </div>
    )
}

export default ScreenWrapper